import React from 'react'
import styles from './HistoryModal.module.scss'
import { XMarkIcon } from '@heroicons/react/24/solid'
import OfferHistoryItem from './OfferHistoryItem'

const HistoryModal = ({ onClose, offerHistory }) => {
	return (
		<div className={styles.container}>
			<div className={styles.returnContainer}>
				<XMarkIcon className={styles.returnIcon} onClick={onClose} />
			</div>
			<div className={styles.itemContainer}>
				{offerHistory.map((item) => {
					if (item.index === offerHistory.length - 1) {
						return (
							<OfferHistoryItem
								key={item.id}
								data={item}
								haveToIndicateChanges={false}
							/>
						)
					} else {
						return <OfferHistoryItem key={item.id} data={item} />
					}
				})}
			</div>
		</div>
	)
}

export default HistoryModal
